/*
    A mixin providing handy access to various store properties, for use in tools and components therein.
 */

import moment from "moment";
import {TextRun} from "docx";

export default {
    computed: {
        doc() {
            return this.$store.state.doc
        },
        docData() {
            return this.$store.state.doc.data
        },
        tool() {
            return this.$store.state.tool
        },
        steps() {
            return this.$store.state.tool.options.steps
        },
        step() {
            return _.find(this.steps, (s) => s.id == this.doc.data.currentStep)
        },
        // default implementation - override in any steps that need validation
        thisStepIsValid() {
            return true
        },
        onFinalStep() {
            return this.step.id == this.steps.length
        },
        help() {
            const tool = this.$store.state.config[this.tool.options.toolName]
            return tool ? tool.help[`step${this.doc.data.currentStep}`] : ''
        },
        config() {
            return this.$store.state.config
        },
        copyrightDate() {
            return moment().format('YYYY')
        },
        creationDate() {
            return moment().format('MM/DD/YYYY')
        },
        exportHeader() {
            return {
                left: `Created ${this.creationDate} with ${this.tool.options.label}`,
                right: `© Jim Wright ${this.copyrightDate}`
            }
        },
        exportFooter() {
            return {
                left: 'For workshop information: jimw13159@gmail.com',
                // right: page number, inserted differently for .docx vs .pdf
            }
        }
    },
    methods: {
        onStep(i) {
            return this.step.id == i
        },
        save() {
            this.$api.debouncedSaveDoc()
        },
        splitTextByLineBreaks(text) {
            return _.filter(text.split('\n\n'),
                            function(l) {
                                return !(l == "")
                            })
        }
    },
    watch: {
        // if we are a step that defines a computed variable thisStepIsValid(), watch this
        // in order to enable/disable the Next Step button (see ToolContainer)
        thisStepIsValid: {
            immediate: true,
            handler: function (newVal, oldVal) { // NB: can't use an arrow function here, as we need 'this'!
                if (newVal != undefined) {
                    this.$store.state.currentStepIsValid = newVal
                }
            }
        }
    }

}
